import { TranslateHelper } from './../../../_helpers/translate-helper';
import { Component, OnInit, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'app-checkbox-input',
    templateUrl: './checkbox-input.component.html',
    styleUrls: ['./checkbox-input.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [MatCheckboxModule, FormsModule, ReactiveFormsModule]
})
export class CheckboxInputComponent implements OnInit {

    constructor(public translateHelper: TranslateHelper) { }

    @Input() icon='';
    @Input() label='';
    @Input() control = true;
    ngOnInit(): void {
    }

}
